/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_Card1_BodyInputs */

const tr_cerez_s2_card1_body = /** @type {(inputs: Cerez_S2_Card1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform'un doğru çalışması için gereklidir (oturum, güvenlik, seçtiğiniz dil ve tema, hata takibi). Bu kayıtlar açık rıza gerektirmez; oturum ve güvenlik kayıtları devre dışı bırakılırsa temel özellikler çalışmaz.`)
};

const en_cerez_s2_card1_body = /** @type {(inputs: Cerez_S2_Card1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are required for the Platform to work correctly (session, security, the language and theme you chose, error tracking). These entries do not require explicit consent; if the session and security entries are disabled, basic features will not work.`)
};

const de_cerez_s2_card1_body = /** @type {(inputs: Cerez_S2_Card1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind für das korrekte Funktionieren der Plattform erforderlich (Sitzung, Sicherheit, die von Ihnen gewählte Sprache und das Design, Fehlerverfolgung). Diese Einträge erfordern keine ausdrückliche Einwilligung; werden die Einträge für Sitzung und Sicherheit deaktiviert, funktionieren die Grundfunktionen nicht.`)
};

const ru_cerez_s2_card1_body = /** @type {(inputs: Cerez_S2_Card1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Они необходимы для корректной работы Платформы (сессия, безопасность, выбранные вами язык и тема, отслеживание ошибок). Эти записи не требуют явного согласия; при отключении записей сессии и безопасности базовые функции работать не будут.`)
};

/**
* | output |
* | --- |
* | "They are required for the Platform to work correctly (session, security, the language and theme you chose, error tracking). These entries do not require expl..." |
*
* @param {Cerez_S2_Card1_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_card1_body = /** @type {((inputs?: Cerez_S2_Card1_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_Card1_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_card1_body(inputs)
	if (locale === "de") return de_cerez_s2_card1_body(inputs)
	if (locale === "ru") return ru_cerez_s2_card1_body(inputs)
	return tr_cerez_s2_card1_body(inputs)
});